import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { NewPrompterReportService, NewPrompterReport } from '../../services/new-prompter-report.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-new-prompter-report',
  templateUrl: './read-new-prompter-report.component.html',
  styleUrls: ['./read-new-prompter-report.component.css']
})
export class ReadNewPrompterReportComponent implements OnInit, OnDestroy {
  loaded: boolean  = false;

  dateFilter: '15days' | 'always' = '15days';
  get days15FromToday(){
    let date = new Date();
    date.setDate(date.getDate() - 15);
    return Utils.stringDate(date);
  }
  receivedAll: boolean = false;

  unfilteredData: any[];
	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Empleado que genera', name: 'name'},
    {title: 'Proyecto', name: 'odpName'},
    {title: 'Cantidad', name: 'employeesQuantity'},
    {title: 'Fecha', name: 'date', sort: 'desc'},
    {title: 'Hora', name: 'time'},
    {title: 'Capturó', name: 'userEmail'},
    { title: 'Acciones', className: 'center w',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
        { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
          styleClass: 'btn-floating btn waves-effect red darken-2', }
          
      ] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
      onDelete: this.onDelete.bind(this),
		}
  };

  subs: Subscription[] = [];

  constructor(
    private service: NewPrompterReportService,
    private settingsService: CatalogsSettingsService,
  ) {
    this.subs[0] = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      this.itemsPerPage = settings.tableQuantity;
    });

    this.subs[1] = this.service.getNewPrompterReports({fromDate: this.days15FromToday}).subscribe(this.onSubscribe);
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  onSubscribe = (newPrompterReports: NewPrompterReport[]) => {
    this.unfilteredData = newPrompterReports.map(report => {
      return {
        name: report.employeeName,
        employeesQuantity: report.employees.length,
        ...report,
      };
    });
    this.filter();
    this.loaded = true;
  };
  onDateFilterChange(){
    console.log(`Changed to ${this.dateFilter}`);
    if(this.dateFilter == 'always' && !this.receivedAll){
      this.receivedAll = true;
      this.loaded = false;
      this.subs[1].unsubscribe();
      this.subs[1] = this.service.getNewPrompterReports().subscribe(this.onSubscribe);
    }else{
      this.filter();
    }
  }
  filter(){
    console.log(`Changed to ${this.dateFilter}`);
    this.data = (this.unfilteredData || []).filter(({date}) => {
      let dateCondition = this.dateFilter == 'always' || date >= this.days15FromToday;
      return dateCondition;
    });
    this.length = this.data.length;
    console.log(`New Length: ${this.length}`);
    this.onChangeTable(this.config);
  }

	onCellClick(data: any): any {
		this.service.windowReplace.view(data.row.id);
  }

  onCreate(){
    //if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.service.windowReplace.add();
  }

	onEdit(data: any) {
    //if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace.edit(data.row.id);
	}

	onDelete(data: any) {
    //if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.service.deleteNewPrompterReport(data.row.id);
	}

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
